import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import BaseStarIcon from '#/shared/components/GeneratedIcons/generic/Star';
import { ClearButton } from '#/shared/components/Styled';
import { GTM_DATA_ATTRIBUTE } from '#/shared/constants';
import GTM_HANDLES from '#/shared/gtm-handles';

export const FavoriteStar = styled(BaseStarIcon).attrs(props => ({
  'aria-hidden': true,
  role: 'img',
  width: 25,
  height: 25,
  stroke: props.$active ? 'transparent' : props.theme.secondaryFontColor,
}))`
  stroke-width: ${props => (props.$active ? 0 : '1px')};
  fill: ${props => (props.$active ? props.theme.trimetOrange : 'transparent')};
`;

export const FavoriteButton = injectIntl(styled(ClearButton).attrs(
  ({ intl, ...props }) => ({
    title: props.isFavorite
      ? intl.formatMessage({ id: 'favorites.unfavbutton_title' })
      : intl.formatMessage({ id: 'favorites.favbutton_title' }),
    ariaPressed: props.isFavorite,
    [GTM_DATA_ATTRIBUTE]: props.isFavorite
      ? GTM_HANDLES.shared.favoriteButtonToggled
      : GTM_HANDLES.shared.favoriteButtonUntoggled,
  })
)`
  background-color: transparent;
  padding: 3px 10px 3px 10px;
  border: 0;
  flex: 0 1 auto;
  display: flex;
  align-items: center;
  @media (any-hover: hover) {
    &:hover {
      opacity: ${props => props.theme.inactiveOpacity};
      background-color: transparent;
    }
    &:hover ${FavoriteStar} {
      fill: ${props => props.theme.trimetOrange};
      stroke-width: 0;
    }
  }
`);
